<div class="dialog-container">
    <h1 class="condensed dialog-title">Exporteer ShapeFile</h1>
    <div class="dialog-content">
        <div class="w-100">
            <div *ngIf="!exporting" class="pb-3">
                <p>Exporteer alle locaties naar een ShapeFile (geografisch formaat).</p>
                <div *ngFor="let status of statuses; let i = index">
                    <mat-checkbox
                        [(ngModel)]="filter['status_' + status.id]"
                        [disabled]="filter['status_' + status.id + '_disable']"
                        [value]="status.id"
                        color="primary">
                        <span [innerHTML]="status['img'] | safeHtml"></span>
                        {{status.name}}
                        <ng-container *ngIf="statusCounts.has(status.id)">
                            ({{statusCounts.get(status.id)}})
                        </ng-container>
                    </mat-checkbox>
                </div>
            </div>
            <div *ngIf="!exporting && shapefileImports.length > 0" class="shapefile-imports pb-3">
                <h2 class="h5">Aangeleverde shapefile bijwerken</h2>
                <p>Download het aangeleverde shapefile, aangevuld met per object de status, CROW, datum uitgevoerd, opmerking en punaisenummer.</p>
                <div *ngFor="let shapefileImport of shapefileImports" class="shapefile-import">
                    <div class="shapefile-import-info">
                        {{shapefileImport.filename}}
                        <small>{{shapefileImport.created_at | date:'d-M-yyyy HH:mm'}} &middot; {{shapefileImport.pushpin_parts_count}} delen</small>
                    </div>
                    <button (click)="exportShapefileImport(shapefileImport)" [disabled]="exportingShapefileImportId !== null"
                            color="primary" mat-stroked-button>
                        {{exportingShapefileImportId === shapefileImport.id ? 'Bezig...' : 'Download'}}
                    </button>
                </div>
            </div>
            <div *ngIf="exporting" class="w-100">
                Bezig met exporteren...
                <br><br>
                <mat-progress-bar class="w-100" mode="indeterminate"></mat-progress-bar>
                <br><br>
            </div>
        </div>
    </div>
    <div class="d-flex flex-wrap">
        <button (click)="onNoClick()" mat-button>Sluiten</button>
        <div class="spacer"></div>
        <button (click)="export()" cdkFocusInitial color="primary" mat-raised-button>Download ShapeFile</button>
    </div>
</div>
